<template>
  <v-layout>
    <v-flex>
        <h2>Perusprofiilit</h2>
        <v-card flat>
            <v-img class="white--text" src='img/profiilit_taustalla/a-a-a.png'>
            <v-container fill-height fluid pa-0>
                <v-layout fill-height align-center>
                <v-flex offset-xs1 xs6 align-end flexbox>
                    <h2 class="headline">Tuleva metsänomistaja</h2>
                    <p>{{ getDescription('Tuleva metsänomistaja') }}</p>
                </v-flex>
                </v-layout>
            </v-container>
            </v-img>
        </v-card>
        <v-card flat>
            <v-img class="white--text" src='img/profiilit_taustalla/n-n-n.png'>
            <v-container fill-height fluid pa-0>
                <v-layout fill-height align-center>
                <v-flex offset-xs1 xs6 align-end flexbox>
                    <h2 class="headline">Nautiskelija</h2>
                    <p>{{ getDescription('Nautiskelija') }}</p>
                </v-flex>
                </v-layout>
            </v-container>
            </v-img>
        </v-card>
        <v-card flat>
            <v-img class="white--text" src='img/profiilit_taustalla/s-s-s.png'>
            <v-container fill-height fluid pa-0>
                <v-layout fill-height align-center>
                <v-flex offset-xs1 xs6>
                    <h2 class="headline">Metsäseikkailija</h2>
                    <p>{{ getDescription('Metsäseikkailija') }}</p>
                </v-flex>
                </v-layout>
            </v-container>
            </v-img>
        </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'BaseProfiles',
  computed: {
    ...mapState('metsankayttaja', ['currentAnswers', 'points', 'profiles', 'results']),
  },
  data: function() {
    return {
    }
  },
  methods: {
      getDescription: function(profile) {
        return this.profiles.description[this.profiles.name.legs[profile]] + ' ' + this.profiles.description[this.profiles.name.torso[profile]] + ' ' + this.profiles.description[this.profiles.name.head[profile]];
      }
  },
  mounted() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.application .theme--light.v-card, .theme--light .v-card {
    background:#f8fafa;
}
</style>
